import { Fragment, useEffect, useState } from 'react';

import { Menu, MenuButton, MenuItems, Transition } from '@headlessui/react';

import { AnimatePresence } from 'framer-motion';

import { RootState, useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import { selectUser } from '@/store/slices/authSlice';
import { fetchCompanies } from '@/store/slices/companySlice';

import { ChevronDownIcon } from '@heroicons/react/24/outline';

import Company from '../company';

import DefaultTab from './tabs/default.tsx';
import NotificationTab from './tabs/notification.tsx';

import { TabType } from './types/types.ts';

const Avatar = () => {
  const [activeTab, setActiveTab] = useState<TabType>('default');

  const { companies } = useSelector((state: RootState) => state.company);

  const [isNameDropdownOpen, setIsNameDropdownOpen] = useState(false);

  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  const handleToggleDropdown = () => {
    setIsNameDropdownOpen((prev) => !prev);
  };

  return (
    <Menu as="div" className="relative inline-block text-left z-10">
      <MenuButton className="size-10 flex items-center justify-center bg-[#1F2B40] rounded-full text-[#BDE0F5] font-jostSemiBold text-base cursor-pointer focus:outline-none">
        {user?.first_name?.charAt(0)}
        {user?.last_name?.charAt(0)}
      </MenuButton>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95">
        <MenuItems className="absolute right-0 mt-2 w-[296px] bg-white rounded-2xl shadow-lg focus:outline-none">
          <div className="p-4">
            <div
              className={`flex gap-1 items-center pb-2 border-b border-gray-200 ${
                companies?.length > 1 ? 'cursor-pointer' : ''
              }`}
              onClick={
                companies?.length > 1 ? handleToggleDropdown : undefined
              }>
              <span className="font-jostBold text-lg text-gray-800">
                {user?.full_name}
              </span>
              {companies?.length > 1 && (
                <ChevronDownIcon
                  className={`size-5 text-gray-500 transition-transform ${
                    isNameDropdownOpen ? 'rotate-180' : ''
                  }`}
                />
              )}
            </div>

            {isNameDropdownOpen && (
              <Company />
            )}

            {companies.length === 1 && (
              <Company />
            )}

            <AnimatePresence mode="wait">
              {activeTab === 'default' && (
                <DefaultTab setActiveTab={setActiveTab} />
              )}
              {activeTab === 'notification' && (
                <NotificationTab setActiveTab={setActiveTab} />
              )}
            </AnimatePresence>
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
};

export default Avatar;
